import React, { useEffect, useState } from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { create } from "jss";
import rtl from "jss-rtl";
import MomentUtils from "@date-io/moment";
import { SnackbarProvider } from "notistack";
import {
	jssPreset,
	LinearProgress,
	StylesProvider,
	ThemeProvider
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import Auth from "src/components/Auth";
import CookiesNotification from "src/components/CookiesNotification";
import SettingsNotification from "src/components/SettingsNotification";
import GoogleAnalytics from "src/components/GoogleAnalytics";
import ScrollReset from "src/components/ScrollReset";
import useSettings from "src/hooks/useSettings";
import { createTheme } from "src/theme";
import Routes from "src/Routes";
import _ from "lodash";
import { SUPPOER_LOCALES } from "src/utils/utils";
import GlobalSnackbars from "./components/GlobalSnackbars";
// import DateLocalizationProvider from "./components/DateLocalizationProvider";
import { preLoad } from "./utils/preloadModel";
// import { useTranslation } from "react-i18next";

const history = createBrowserHistory();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

function App() {
	const { settings } = useSettings();
	const [initDone, setInitDone] = useState(false);
	// const { i18n } = useTranslation();
	// const loadLocales = () => {
	// 	let currentLocale = intl.determineLocale({
	// 		urlLocaleKey: "lang",
	// 		cookieLocaleKey: "lang"
	// 	});

	// 	// 如果没找到，则默认为汉语
	// 	if (!_.find(SUPPOER_LOCALES, { value: currentLocale })) {
	// 		currentLocale = "zh-CN";
	// 	}

	// 	fetch(`/locales/${currentLocale}.json`)
	// 		.then(res => res.json())
	// 		.then(data => {
	// 			// init 方法将根据 currentLocale 来加载当前语言环境的数据
	// 			return intl.init({
	// 				currentLocale,
	// 				locales: {
	// 					[currentLocale]: data
	// 				},
	// 				warningHandler: () => {}
	// 			}); 
	// 		})
	// 		.then(() => {
	// 			// After loading CLDR locale data, start to render
	// 			setInitDone(true);
	// 		});
	// };

	useEffect(() => {
		// loadLocales();
		preLoad();
	}, []);

	// if (!initDone)
	//   return <LinearProgress />;

	return (
		<ThemeProvider theme={createTheme(settings)}>
			<StylesProvider jss={jss}>
				<MuiPickersUtilsProvider utils={MomentUtils} >
					<SnackbarProvider
						maxSnack={5}
						anchorOrigin={{ vertical: "top", horizontal: "center" }}
					>
						<Router history={history}>
							<Auth>
								<ScrollReset />
								<GoogleAnalytics />
								<CookiesNotification />
								<SettingsNotification />
								<Routes />
								<GlobalSnackbars />
							</Auth>
						</Router>
					</SnackbarProvider>
				</MuiPickersUtilsProvider>
			</StylesProvider>
		</ThemeProvider>
	);
}

export default App;
